import { VisualizerProject, Visualizers } from "@app/shared";
import { getRecentProjects } from "@app/shared/src/api/VisualizerControllerClient.gen";
import { useState } from "react";
import { useFetch } from "../../../hooks";
import { DashboardLayout } from "../../layouts";
import { IconLink, Icons, MediaSelectorItem, Select } from "../../shared";
import { RequiresGoogleMaps } from "../../shared/maps/RequiresGoogleMaps";
import { NewProjectWizard } from "./NewProjectWizard";
import { ProjectView, ViewPaneLayout } from "./ProjectView";

type DataVisualizerProps = {
};


export const DataVisualizer: React.FC<DataVisualizerProps> = (props) => {
    const [openProjectId, setOpenProjectId] = useState<string>();
    const [recent, , recentApi] = useFetch(getRecentProjects);
    const [showWizard, setShowWizard] = useState(false);
    const [viewLayout, setViewLayout] = useState(ViewPaneLayout.Pane_2);
    const [pageTitle, setPageTitle] = useState("Data Visualizer");

    const openProject = (p?: VisualizerProject) => {
        setPageTitle(p?.name || "Data Visualizer");
        setShowWizard(false);
        setOpenProjectId(p?.id);
    };

    const handleCloseProjectClick = async () => {
        openProject();
        await recentApi.refreshData();
    };

    const layoutOptions = [
        { label: "1 Pane", value: ViewPaneLayout.Pane_1 },
        { label: "2 Pane", value: ViewPaneLayout.Pane_2 },
        { label: "3 Pane", value: ViewPaneLayout.Pane_3 },
    ];

    return (
        <RequiresGoogleMaps>
            <DashboardLayout
                centerChildren={pageTitle}
                rightChildren={<div>
                    {openProjectId &&
                        <div className="flex flex-row gap-3 items-center ">
                            <Select options={layoutOptions} value={viewLayout} onChange={(e) => {
                                setViewLayout(parseInt(e.target.value) as ViewPaneLayout);
                            }} />
                            <IconLink Icon={Icons.Close} onClick={handleCloseProjectClick} iconSize={32} />
                        </div>
                    }
                </div>}
            >
                {!openProjectId && !showWizard &&
                    <>
                        <MediaSelectorItem onClick={() => setShowWizard(true)} >
                            <div className="pb-8">
                                <p className="font-bold text-7xl text-center">+</p>
                                <p>Create New Project</p>
                            </div>
                        </MediaSelectorItem>
                        <div className="font-bold mt-5">
                            Recent Projects
                        </div>
                        <div className="flex flex-col gap-3 ">
                            {!recentApi.isLoading && !recent &&
                                <>No recent projects found.</>
                            }
                            {recent && recent.map((p, i) =>
                                <div key={p.id} onClick={() => openProject(p)} className="p-2 border-separators-page border cursor-pointer hover:bg-background-page-highlight-gray"><b>{p.name}</b>({p.created?.toDateString()})<br />
                                    {p.device && `Device: ${p.device.name}`}<br />
                                    {p.radarStartDate && `Radar Start: ${p.radarStartDate.toDateString()}`}<br />
                                    {p.videoStartDate && `Video Start: ${p.videoStartDate.toDateString()}`}<br />
                                    {/* Radar: Mar 30, 2025 - April 5, 2025<br />
                                Video: Mar 30, 2025 - April 5, 2025<br />
                                Annotation Data: none<br />
                                Device: none<br /> */}
                                </div>
                            )}
                        </div>
                    </>
                }

                {showWizard &&
                    <NewProjectWizard onFinished={
                        async (p) => {
                            //Save the project
                            if (p) {
                                await Visualizers.saveProject(p);
                            }
                            //Now open it
                            openProject(p);
                        }
                    } />
                }

                {openProjectId &&
                    <ProjectView projectId={openProjectId} onClose={handleCloseProjectClick} layout={viewLayout} />
                }


            </DashboardLayout>
        </RequiresGoogleMaps>
    );
}